/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrchestratorAdminJobItem { 
    video_id: string;
    state: string;
    priority: number;
    reprocess: boolean;
    s3_path: string;
    machine_id?: string | null;
    preferred_machine?: string | null;
    prefer_deadline?: string | null;
    created_at: string;
    updated_at: string;
    queue_type?: OrchestratorAdminJobItem.QueueTypeEnum | null;
    queue_position?: number | null;
    global_queue_position?: number | null;
}
export namespace OrchestratorAdminJobItem {
    export const QueueTypeEnum = {
        Priority: 'priority',
        Normal: 'normal'
    } as const;
    export type QueueTypeEnum = typeof QueueTypeEnum[keyof typeof QueueTypeEnum];
}


